import React, { useState } from "react";
import { connect } from "react-redux";
import "./ProgressBar.scss";
import { useIntl } from "react-intl";

export default connect(
	(state) => ({}),
	{}
)(({ labels, className, isActive }) => {
	const { formatMessage } = useIntl();

	return (
		<div className={`progress-bar flex direction-row align-items-end justify-content-start ${className}`}>
			{labels.map((labelItem) => {
				return (
					<div className="progress-bar-item flex direction-col align-items-start">
						<div className="label">
							{labelItem.isActive ? (
								formatMessage({ id: `public.progressBar.${labelItem.label}` })
							) : (
								<> </>
							)}
						</div>
						<div
							className={`progress-bar-item-element ${
								labelItem.isCompleted
									? "progress-bar-item-element-complete"
									: labelItem.isActive
									? "progress-bar-item-element-active"
									: ""
							}`}
						></div>
					</div>
				);
			})}
		</div>
	);
});
